import { render, staticRenderFns } from "./UserAgreementPage.vue?vue&type=template&id=f5524838&scoped=true&"
import script from "./UserAgreementPage.vue?vue&type=script&lang=js&"
export * from "./UserAgreementPage.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreementPage.vue?vue&type=style&index=0&id=f5524838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5524838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5524838')) {
      api.createRecord('f5524838', component.options)
    } else {
      api.reload('f5524838', component.options)
    }
    module.hot.accept("./UserAgreementPage.vue?vue&type=template&id=f5524838&scoped=true&", function () {
      api.rerender('f5524838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserAgreementPage.vue"
export default component.exports